import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle
} from '@ionic/react'
import dayjs from 'dayjs'
import React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { State } from '../store'

interface StateProps {
  lastScan?: number
}

type Props = RouteComponentProps<{}> & StateProps

const LastScansInternal: React.FC<Props> = (props) => {
  if (!props.lastScan) {
    return null
  }

  const continueLast = async () => {
    await props.history.push({ pathname: '/person' })
  }

  return (
    <IonCard style={{'--background': '#FFF'}}>
      <IonCardHeader>
        <IonCardSubtitle>{dayjs(props.lastScan).format('YYYY-MM-DD HH:mm')}</IonCardSubtitle>
        <IonCardTitle>Offener Vorgang</IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <IonButton onClick={continueLast}>
          jetzt weiter machen
        </IonButton>
      </IonCardContent>
    </IonCard>
  )
}

export const LastScans = connect<StateProps, { }, {}, State>(
  ({quote}) => ({
    lastScan: quote.created,
  }),
)(withRouter(LastScansInternal))
